import { render } from "./TemplatesModal.vue?vue&type=template&id=538e353b&scoped=true"
import script from "./TemplatesModal.vue?vue&type=script&lang=js"
export * from "./TemplatesModal.vue?vue&type=script&lang=js"

import "@/assets/css/components/TemplateModal.scss?vue&type=style&index=0&id=538e353b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538e353b"]])

export default __exports__